import { z } from "zod";

export const DischargeLetterInternalMedicineFormSchema = z.object({
  additional_diagnostic_findings: z.string().optional(),
  anamnesis: z.string().optional(),
  clinical_course: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  physical_status: z.string().optional(),
  social_anamnesis: z.string().optional(),
  // vital_signs: z.string().optional(), TODO: wait for feedback
});
